import { APIPlayer } from "../apis/api";

export function Scores(props: { playerScores: Array<APIPlayer> }) {
    let elements = props.playerScores.map((ps) => {
        return (
            <div key={ps.name}>
                <h3>{ps.name}</h3>
                <div>{ps.score}</div>
                <div>({ps.tray_tiles} tiles remaining)</div>
            </div>
        );
    });

    return <div className="scoring">{elements}</div>;
}
